export default "__VITE_ASSET__CkNSFAUO__"